import { useDocumentTitle } from "@/i18n";
import { VerificationPageView } from "./_components";

export default function VerificationPage() {
  useDocumentTitle("verification.page");
  return <VerificationPageView />;
}
